import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {environment} from '../../../Environment/environment'
import { map, Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class FServiceService {
  baseurl:string="";
  constructor(private http:HttpClient) {
    this.baseurl = environment.apiUrl;
   }
   public getUnitVersion():Observable<any>{
    return this.http.get<any[]>(this.baseurl + 'F/GetUnitVersion');
  }
  public getInputType():Observable<any>{
    return this.http.get<any[]>(this.baseurl + 'F/GetTypeofUnit');
  }
  
  public getOutputShaft(Size:any,UnitVersion:any):Observable<any>{
    const url = `${this.baseurl}F/GetOutputShaft?Size=${Size}&UnitVersion=${UnitVersion}`;
    return this.http.get<any[]>(url).pipe(map((response:any) => response));
  }
  public getBoreDia(Size:any):Observable<any>{
    const url = `${this.baseurl}F/GetBoreDia?Size=${Size}`;
    return this.http.get<any[]>(url).pipe(map((response:any) => response));
  }
  public getMotorAdaptor(typeOfUnit:any):Observable<any>{
    const url = `${this.baseurl}F/GetMotorAdaptor?typeOfUnit=${typeOfUnit}`;
    return this.http.get<any[]>(url).pipe(map((response:any) => response));
  }
  public getAssemblyPosition(typeOfUnit:any,unitVersion:any,outputShaft:any):Observable<any>{
    const url = `${this.baseurl}F/GetAssemblyPosition?typeOfUnit=${typeOfUnit}&unitVersion=${unitVersion}&outputShaft=${outputShaft}`;
    return this.http.get<any[]>(url).pipe(map((response:any) => response));
  }
  public getSpecialFeature(unitVersion:any):Observable<any>{
    const url = `${this.baseurl}F/GetSpecialFeature?unitVersion=${unitVersion}`;
    return this.http.get<any[]>(url).pipe(map((response:any) => response));
  }
   public getSpecification(request:any):Observable<any>{
    debugger;
    const httpParams = new HttpParams({fromObject:request});
    const headers = new HttpHeaders({'Content-Type':'application/json'});
    return this.http.get(this.baseurl+'F/GetSpecification',{
      params:httpParams,
      headers:headers,
      observe:'response',
      responseType:'json'
    });
  }
  public getLargerReducer(request:any):Observable<any>{
    const httpParams = new HttpParams({fromObject:request});
    const headers = new HttpHeaders({'Content-Type':'application/json'});
    return this.http.get(this.baseurl+'F/GetLargerReducer',{
      params:httpParams,
      headers:headers,
      observe:'response',
      responseType:'json'
    });
  }
  public getSmallerReducer(request:any):Observable<any>{
    const httpParams = new HttpParams({fromObject:request});
    const headers = new HttpHeaders({'Content-Type':'application/json'});
    return this.http.get(this.baseurl+'F/GetSmallerReducer',{
    params:httpParams,
    headers:headers,
    observe:'response',
    responseType:'json'
    });
  }
}
